import toastr from 'reactjs-toastr';
import Utils from './Utils';

class NotificationService {
  static notify = (type, title, message, timeout) => {
    toastr[type](message, title, timeout ? {displayDuration : timeout} : null);
  };

  static searchErrorValue = (error, key, index) => {
    if (Array.isArray(error)) {
      error.forEach((value, indexError) => {
        if (value) {
          this.searchErrorValue(value, indexError, key);
        }
      });
    }
    else if (Utils.isObject(error)) {
      Object.values(error).forEach((value, indexError) => {
        if (value) {
          this.searchErrorValue(value, indexError, key);
        }
      });
    }
    else {
      if (!Utils.isNull(error) && !error.startsWith('Invalid page')) {
        var keyError = !Utils.isNumber(key) ? key : index;
        if (keyError === 'key' && error === "This field must be unique.") {
          this.notify('error', 'This field name already exists. Please choose a different name');
        }
        else if(keyError === 'email' && error === "Enter a valid email address.") {
          this.notify('error', error);
        }
        else if(keyError === 'email' && error === "The email address you have provided is already in use. Please use a different email address.") {
          this.notify('error', error);
        }
        else if (keyError === 'email') {
          this.notify('error', 'Email address must be unique.');
        }
        else if (keyError === 'active_templates' && error === "This list may not be empty.") {
          this.notify('error', 'Workflow launch cannot be performed when no tasks are included. Please relaunch with active tasks in order to proceed.');
        }
        else if (keyError !== 'type') {
          this.notify('error', error);
        }
        else {
          this.notify('error', error);
        }
      }
    }
    return true;
  };

  static error = (error) => {
    if (!Utils.isNull(error) && error.data !== undefined) {
      if (Utils.isObject(error.data)) {
        Object.values(error.data).forEach( (value, index) => {
          this.searchErrorValue(value, index);
        });
      }
      else if (!Utils.isNull(error.data) && !error.data.startsWith('Invalid page')) {
        this.notify('error', error.data);
      }
      else {
        this.notify('error', 'An unexpected error has occurred!');
      }
    }
    else {
      if (Utils.isObject(error)) {
        Object.values(error).forEach( (value, index) => {
          this.searchErrorValue(value, index);
        });
      }
      else if (error && !error.startsWith('Invalid page')) {
        this.notify('error', error);
      }
      else {
        this.notify('error', 'An unexpected error has occurred!');
      }
    }
  };

}

export default NotificationService;